var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#D8D8D8;fill-opacity:0;}\n\t.st1{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-\u673A\u5668\u5E73\u53F0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5BFC\\u822A\\u4F18\\u5316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-51, -40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-\\u673A\\u5668\\u5E73\\u53F0",
    transform: "translate(50, 39)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 1,
    y: 1,
    className: "st0",
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    className: "st1",
    d: "M15,2c0.6,0,1,0.4,1,1s-0.4,1-1,1c-0.1,0-0.2,0-0.3,0l-2.2,2.2c1.2,0.9,2.1,2.3,2.4,3.8 l0.1,0c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1v2H3v-2c-0.6,0-1-0.4-1-1v-1c0-0.6,0.4-1,1-1l0.1,0c0.3-1.6,1.1-2.9,2.4-3.8L3.3,4 C3.2,4,3.1,4,3,4C2.4,4,2,3.6,2,3s0.4-1,1-1s1,0.4,1,1c0,0.1,0,0.2,0,0.3l2.4,2.4C7.1,5.2,8,5,9,5s1.9,0.2,2.7,0.6L14,3.3 c0-0.1,0-0.2,0-0.3C14,2.4,14.4,2,15,2z M9,6c-2.8,0-5,2.2-5,5v3h10v-3c0-2.7-2.1-4.9-4.8-5L9,6z M11.5,9c0.8,0,1.5,0.7,1.5,1.5 S12.3,12,11.5,12h-5C5.7,12,5,11.3,5,10.5S5.7,9,6.5,9H11.5z M11.5,10h-5C6.2,10,6,10.2,6,10.5S6.2,11,6.5,11h5 c0.3,0,0.5-0.2,0.5-0.5S11.8,10,11.5,10z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.a2eb0d30b3fe18968744691debe14f82.svg";
export { ForwardRef as ReactComponent };